var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBannerTitle = function SvgBannerTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 740 157.729"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__a",
    x1: 0.5,
    y1: -0.041,
    x2: 0.5,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__b",
    x1: 0.5,
    y1: -0.026,
    x2: 0.5,
    y2: 0.911,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__c",
    x1: 0.5,
    y1: -0.006,
    x2: 0.5,
    y2: 0.819,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__d",
    x1: 0.5,
    y1: 0.092,
    x2: 0.5,
    y2: 0.836,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__e",
    x1: 0.5,
    y1: -0.005,
    x2: 0.5,
    y2: 0.819,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__f",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.814,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__g",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.813,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__h",
    x1: 0.5,
    y1: 0.061,
    x2: 0.5,
    y2: 0.842,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__i",
    x1: 0.5,
    y1: 0.058,
    x2: 0.5,
    y2: 0.832,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__j",
    x1: 0.5,
    y1: 0.041,
    x2: 0.5,
    y2: 0.827,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__k",
    x1: 0.5,
    y1: -0.252,
    x2: 0.5,
    y2: 0.884,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__l",
    x1: 0.5,
    y1: -0.147,
    x2: 0.5,
    y2: 0.894,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__m",
    x1: 0.5,
    y1: -0.084,
    x2: 0.5,
    y2: 0.816,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__n",
    x1: 0.5,
    y1: -0.03,
    x2: 0.5,
    y2: 0.83,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__o",
    x1: 0.5,
    y1: -0.108,
    x2: 0.5,
    y2: 0.817,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__p",
    x1: 0.5,
    y1: -0.031,
    x2: 0.5,
    y2: 0.83,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__q",
    x1: 0.5,
    y1: -0.039,
    x2: 0.5,
    y2: 0.828,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__r",
    x1: 0.5,
    y1: 0.007,
    x2: 0.5,
    y2: 0.799,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__s",
    x1: 0.5,
    y1: -0.188,
    x2: 0.5,
    y2: 0.9,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__t",
    x1: 0.5,
    y1: -0.189,
    x2: 0.5,
    y2: 0.89,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__u",
    x1: 0.5,
    y1: -0.207,
    x2: 0.5,
    y2: 0.888,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__v",
    x1: 0.5,
    y1: -6.089,
    x2: 0.5,
    y2: 0.301,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__w",
    x1: 0.5,
    y1: -6.089,
    x2: 0.5,
    y2: 0.301,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__x",
    x1: 0.5,
    y1: -0.184,
    x2: 0.5,
    y2: 0.889,
    xlinkHref: "#banner-title_svg__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "banner-title_svg__y",
    x1: 0.5,
    y1: -6.075,
    x2: 0.5,
    y2: 4.212,
    xlinkHref: "#banner-title_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 7668"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 7660"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19064",
    d: "M134.03 213.318v11.659h18.8v10.838h-18.8v12.645h21.265v11.249h-35.3v-57.64h35.3v11.249Z",
    transform: "translate(-119.99 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19065",
    d: "m202.44 259.708-11.74-17.653-10.344 17.653h-15.932L182.9 230.4l-18.885-28.327h16.34l11.576 17.407 10.181-17.407h15.928l-18.31 29.062 19.048 28.573Z",
    transform: "translate(-119.925 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19066",
    d: "M270.162 229.78a16.9 16.9 0 0 1-7.06 6.692 24.856 24.856 0 0 1-11.823 2.545h-8.7v20.691h-14.044v-57.639h22.743a25.886 25.886 0 0 1 11.659 2.382 16.371 16.371 0 0 1 7.143 6.569 19.091 19.091 0 0 1 2.382 9.606 18.561 18.561 0 0 1-2.3 9.154Zm-13.962-3.818a8.211 8.211 0 0 0 0-10.674q-1.971-1.888-5.994-1.889h-7.635v14.451h7.635q4.028.001 5.994-1.888Z",
    transform: "translate(-119.83 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19067",
    d: "M296.52 248.87h18.392v10.838h-32.431v-57.639h14.039Z",
    transform: "translate(-119.751 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19068",
    d: "M336.734 256.506a28.222 28.222 0 0 1-10.756-10.55 31.04 31.04 0 0 1 0-30.42 28.33 28.33 0 0 1 10.756-10.509 31.289 31.289 0 0 1 29.8 0 27.741 27.741 0 0 1 10.674 10.509 31.466 31.466 0 0 1-.041 30.42 28.023 28.023 0 0 1-10.674 10.55 31.208 31.208 0 0 1-29.763 0Zm25.945-13.629q4.145-4.6 4.146-12.152 0-7.636-4.146-12.193a14.209 14.209 0 0 0-11.043-4.557q-6.979 0-11.125 4.516t-4.146 12.234q0 7.636 4.146 12.193t11.125 4.557a14.142 14.142 0 0 0 11.043-4.598Z",
    transform: "translate(-119.692 -148.678)",
    fill: "url(#banner-title_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19069",
    d: "m420.993 259.708-11.986-21.758h-3.367v21.758H391.6v-57.639h23.564a25.943 25.943 0 0 1 11.618 2.382 16.417 16.417 0 0 1 7.184 6.528 18.214 18.214 0 0 1 2.381 9.237 17.157 17.157 0 0 1-3.243 10.263 17.456 17.456 0 0 1-9.565 6.4l13.3 22.826Zm-15.353-31.693h8.7q3.858 0 5.787-1.889a7.13 7.13 0 0 0 1.93-5.337 6.909 6.909 0 0 0-1.93-5.173q-1.93-1.888-5.787-1.889h-8.7Z",
    transform: "translate(-119.59 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19070",
    d: "M461.88 213.318v11.659h18.8v10.838h-18.8v12.645h21.266v11.249h-35.3v-57.64h35.3v11.249Z",
    transform: "translate(-119.507 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19071",
    d: "M556.615 202.069v11.249h-15.27v46.39H527.3v-46.39h-15.268v-11.249Z",
    transform: "translate(-119.413 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19072",
    d: "M616.306 202.069v57.639h-14.04v-23.729h-21.84v23.729h-14.04v-57.639h14.04v22.579h21.84v-22.579Z",
    transform: "translate(-119.333 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19073",
    d: "M643.143 213.318v11.659h18.8v10.838h-18.8v12.645h21.266v11.249H629.1v-57.64h35.3v11.249Z",
    transform: "translate(-119.24 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19074",
    d: "M705.937 258.231a18.461 18.461 0 0 1-8.006-6.076 16.586 16.586 0 0 1-3.161-9.688h14.944a7.237 7.237 0 0 0 2.216 4.885 7.122 7.122 0 0 0 4.926 1.683 7.7 7.7 0 0 0 4.926-1.437 4.809 4.809 0 0 0 1.807-3.982 4.718 4.718 0 0 0-1.437-3.531 11.621 11.621 0 0 0-3.53-2.3 57.074 57.074 0 0 0-5.954-2.053 64.784 64.784 0 0 1-9.113-3.448 16.831 16.831 0 0 1-6.076-5.09 14.18 14.18 0 0 1-2.545-8.786q0-8.046 5.83-12.6t15.189-4.557q9.524 0 15.354 4.557t6.24 12.685h-15.188a5.946 5.946 0 0 0-2.053-4.392 7.231 7.231 0 0 0-4.844-1.6 6.037 6.037 0 0 0-4.105 1.354 4.887 4.887 0 0 0-1.56 3.9 4.833 4.833 0 0 0 2.628 4.351 42.9 42.9 0 0 0 8.21 3.366 76.253 76.253 0 0 1 9.073 3.613 17.276 17.276 0 0 1 6.034 5.008 13.406 13.406 0 0 1 2.545 8.456 16.592 16.592 0 0 1-2.5 8.949 17.54 17.54 0 0 1-7.267 6.4 24.862 24.862 0 0 1-11.249 2.381 29.628 29.628 0 0 1-11.334-2.048Z",
    transform: "translate(-119.144 -148.678)",
    fill: "url(#banner-title_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19075",
    d: "m783.034 259.708-19.378-25.453v25.453h-14.038v-57.639h14.039v25.289l19.213-25.289h16.5l-22.33 28.245 23.154 29.394Z",
    transform: "translate(-119.063 -148.677)",
    fill: "url(#banner-title_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19076",
    d: "m858.981 202.069-19.951 38.59v19.049h-14.041v-19.049l-19.951-38.59h15.928l11.166 24.139 11.084-24.139Z",
    transform: "translate(-118.981 -148.677)",
    fill: "url(#banner-title_svg__a)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 7661"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19077",
    d: "M132.349 288.388v2.371h-4.714V306.1h-2.906v-15.341h-4.739v-2.371Z",
    transform: "translate(-119.99 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19078",
    d: "M159.84 289.666a1.86 1.86 0 0 1 1.325-3.186 1.77 1.77 0 0 1 1.3.535 1.91 1.91 0 0 1 0 2.651 1.77 1.77 0 0 1-1.3.535 1.8 1.8 0 0 1-1.325-.535Zm2.752 2.4V306.1h-2.905v-14.039Z",
    transform: "translate(-119.932 -148.552)",
    fill: "url(#banner-title_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19079",
    d: "M201.574 289.472a7.753 7.753 0 0 1 3.288 3.11 9.348 9.348 0 0 1 1.16 4.727 9.142 9.142 0 0 1-1.16 4.689 7.657 7.657 0 0 1-3.288 3.045 11 11 0 0 1-4.956 1.058h-5.784v-17.713h5.784a10.784 10.784 0 0 1 4.956 1.084Zm-.191 12.577a6.468 6.468 0 0 0 1.656-4.74 6.683 6.683 0 0 0-1.656-4.816 6.283 6.283 0 0 0-4.765-1.734h-2.88v12.972h2.88a6.4 6.4 0 0 0 4.765-1.683Z",
    transform: "translate(-119.886 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19080",
    d: "M245.2 298.5a4.549 4.549 0 0 1 .292 5.264 4.755 4.755 0 0 1-2.026 1.707 7.169 7.169 0 0 1-3.084.624H233.3v-17.707h6.753a7.231 7.231 0 0 1 3.109.613 4.569 4.569 0 0 1 1.963 1.642 4.183 4.183 0 0 1 .662 2.307 3.958 3.958 0 0 1-.814 2.549 4.756 4.756 0 0 1-2.192 1.5 3.926 3.926 0 0 1 2.419 1.501Zm-9-2.675h3.6a3.449 3.449 0 0 0 2.229-.65 2.267 2.267 0 0 0 .8-1.873 2.315 2.315 0 0 0-.8-1.874 3.364 3.364 0 0 0-2.229-.675h-3.593Zm6.243 7.187a2.466 2.466 0 0 0 .841-1.988 2.578 2.578 0 0 0-.892-2.064 3.517 3.517 0 0 0-2.369-.764H236.2v5.53h3.924a3.474 3.474 0 0 0 2.327-.709Z",
    transform: "translate(-119.823 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19081",
    d: "M318.951 288.388V306.1h-2.9v-7.747h-8.334v7.747h-2.9v-17.712h2.9v7.6h8.334v-7.6Z",
    transform: "translate(-119.718 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19082",
    d: "M357.855 302.482h-7.416l-1.275 3.618h-3.032l6.345-17.737h3.364l6.345 17.737h-3.057Zm-.816-2.371-2.879-8.232-2.905 8.232Z",
    transform: "translate(-119.657 -148.549)",
    fill: "url(#banner-title_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19083",
    d: "M389.584 292.543a8.623 8.623 0 0 1 3.288-3.225 9.67 9.67 0 0 1 9.582.229 7.912 7.912 0 0 1 3.2 3.938h-3.494a4.682 4.682 0 0 0-1.911-2.09 5.674 5.674 0 0 0-2.829-.687 6.182 6.182 0 0 0-3.135.789 5.5 5.5 0 0 0-2.153 2.268 8 8 0 0 0 0 6.88 5.585 5.585 0 0 0 2.153 2.281 6.11 6.11 0 0 0 3.135.8 5.675 5.675 0 0 0 2.829-.689 4.68 4.68 0 0 0 1.911-2.089h3.491a7.835 7.835 0 0 1-3.2 3.924 9.306 9.306 0 0 1-5.033 1.376 9.153 9.153 0 0 1-4.562-1.159 8.657 8.657 0 0 1-3.275-3.224 9.586 9.586 0 0 1 0-9.327Z",
    transform: "translate(-119.595 -148.55)",
    fill: "url(#banner-title_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19084",
    d: "m443.2 306.1-6.855-7.926v7.926h-2.905v-17.712h2.905v8.079l6.881-8.079h3.644l-7.7 8.869L447 306.1Z",
    transform: "translate(-119.528 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19085",
    d: "M484.655 302.482h-7.416l-1.275 3.618h-3.032l6.345-17.737h3.365l6.345 17.737h-3.059Zm-.816-2.371-2.879-8.232-2.905 8.232Z",
    transform: "translate(-119.47 -148.549)",
    fill: "url(#banner-title_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19086",
    d: "M527.584 288.388v2.371h-4.715V306.1h-2.905v-15.341h-4.74v-2.371Z",
    transform: "translate(-119.408 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19087",
    d: "M569.065 288.388V306.1h-2.905v-7.747h-8.333v7.747h-2.905v-17.712h2.905v7.6h8.333v-7.6Z",
    transform: "translate(-119.35 -148.549)",
    fill: "url(#banner-title_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19088",
    d: "M600.82 305.119a8.6 8.6 0 0 1-3.287-3.237 9.609 9.609 0 0 1 0-9.339 8.627 8.627 0 0 1 3.287-3.225 9.559 9.559 0 0 1 9.123 0 8.526 8.526 0 0 1 3.275 3.225 9.7 9.7 0 0 1 0 9.339 8.5 8.5 0 0 1-3.275 3.237 9.552 9.552 0 0 1-9.123 0Zm7.684-2.165a5.571 5.571 0 0 0 2.153-2.294 7.372 7.372 0 0 0 .777-3.453 7.293 7.293 0 0 0-.777-3.44 5.5 5.5 0 0 0-2.157-2.267 6.62 6.62 0 0 0-6.269 0 5.491 5.491 0 0 0-2.153 2.268 7.28 7.28 0 0 0-.778 3.44 7.359 7.359 0 0 0 .778 3.453 5.559 5.559 0 0 0 2.153 2.294 6.525 6.525 0 0 0 6.269 0Z",
    transform: "translate(-119.289 -148.55)",
    fill: "url(#banner-title_svg__g)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19089",
    d: "M656.219 306.1h-2.905l-8.741-13.225V306.1h-2.905v-17.737h2.905l8.741 13.2v-13.2h2.905Z",
    transform: "translate(-119.222 -148.549)",
    fill: "url(#banner-title_svg__e)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19090",
    d: "M716.712 302.152q2.447-2.115 3.862-3.479a15.682 15.682 0 0 0 2.357-2.841 5.464 5.464 0 0 0 .942-2.955 3.622 3.622 0 0 0-.726-2.4 2.815 2.815 0 0 0-2.28-.866 2.92 2.92 0 0 0-2.332.955 3.976 3.976 0 0 0-.879 2.561h-2.8a6.24 6.24 0 0 1 10.334-4.459 5.435 5.435 0 0 1 1.567 4.077 7.24 7.24 0 0 1-.93 3.529 14.252 14.252 0 0 1-2.217 3.032q-1.288 1.339-3.275 3.1l-1.147 1.02h8.078v2.421h-12.389v-2.114Z",
    transform: "translate(-119.114 -148.551)",
    fill: "url(#banner-title_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19091",
    d: "M755.708 289.677q1.492-2.485 5.136-2.485t5.135 2.485a13.417 13.417 0 0 1 1.491 6.894 13.675 13.675 0 0 1-1.491 6.969q-1.49 2.51-5.135 2.511t-5.136-2.511a13.686 13.686 0 0 1-1.49-6.969 13.428 13.428 0 0 1 1.49-6.894Zm8.64 3.4a4.681 4.681 0 0 0-1.084-2.331 3.69 3.69 0 0 0-4.842 0 4.68 4.68 0 0 0-1.083 2.331 19.332 19.332 0 0 0-.267 3.491 21.241 21.241 0 0 0 .254 3.593 4.493 4.493 0 0 0 1.083 2.344 3.766 3.766 0 0 0 4.868 0 4.494 4.494 0 0 0 1.083-2.344 21.23 21.23 0 0 0 .255-3.593 19.333 19.333 0 0 0-.267-3.488Z",
    transform: "translate(-119.056 -148.551)",
    fill: "url(#banner-title_svg__i)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19092",
    d: "M796.563 302.152q2.447-2.115 3.862-3.479a15.644 15.644 0 0 0 2.357-2.841 5.465 5.465 0 0 0 .942-2.955 3.622 3.622 0 0 0-.726-2.4 2.813 2.813 0 0 0-2.28-.866 2.92 2.92 0 0 0-2.332.955 3.976 3.976 0 0 0-.879 2.561h-2.8a6.24 6.24 0 0 1 10.334-4.459 5.434 5.434 0 0 1 1.567 4.077 7.242 7.242 0 0 1-.93 3.529 14.221 14.221 0 0 1-2.217 3.032q-1.287 1.339-3.275 3.1l-1.147 1.02h8.079v2.421h-12.389v-2.114Z",
    transform: "translate(-118.996 -148.551)",
    fill: "url(#banner-title_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19093",
    d: "M833.687 290.174v-2.651h5.3V306.1h-2.931v-15.926Z",
    transform: "translate(-118.939 -148.55)",
    fill: "url(#banner-title_svg__j)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 7662"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19094",
    d: "M131.69 153.149v1.779h-4.567V169.9h-2.187v-14.972h-4.591v-1.779Z",
    transform: "translate(-119.989 -148.749)",
    fill: "url(#banner-title_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19095",
    d: "M144.321 154.161a1.49 1.49 0 0 1 1.058-2.548 1.371 1.371 0 0 1 1.021.433 1.54 1.54 0 0 1 0 2.115 1.371 1.371 0 0 1-1.021.433 1.438 1.438 0 0 1-1.058-.433Zm2.116 2.571V169.9h-2.188v-13.168Z",
    transform: "translate(-119.954 -148.751)",
    fill: "url(#banner-title_svg__l)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19096",
    d: "M170 154.171a7.179 7.179 0 0 1 3.077 2.92 9.853 9.853 0 0 1 0 8.929A7.054 7.054 0 0 1 170 168.9a10.552 10.552 0 0 1-4.747 1h-5.213v-16.751h5.216a10.343 10.343 0 0 1 4.744 1.022Zm.2 12.21a6.542 6.542 0 0 0 1.707-4.819 6.676 6.676 0 0 0-1.719-4.88 6.608 6.608 0 0 0-4.939-1.754h-3.027V168.1h3.027a6.678 6.678 0 0 0 4.958-1.72Z",
    transform: "translate(-119.931 -148.749)",
    fill: "url(#banner-title_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19097",
    d: "M196.955 162.018a4.372 4.372 0 0 1 1.2 1.49 4.333 4.333 0 0 1-.2 4.193 4.41 4.41 0 0 1-1.887 1.611 6.742 6.742 0 0 1-2.92.589H186.9v-16.752h6a6.8 6.8 0 0 1 2.908.565 4.116 4.116 0 0 1 1.8 1.526 4 4 0 0 1 .6 2.162 3.737 3.737 0 0 1-.805 2.465 4.514 4.514 0 0 1-2.127 1.405 3.551 3.551 0 0 1 1.679.746Zm-7.872-1.634h3.677a3.552 3.552 0 0 0 2.38-.721 2.786 2.786 0 0 0 0-3.99 3.625 3.625 0 0 0-2.428-.721h-3.629Zm6.417 6.945a2.641 2.641 0 0 0 .913-2.138 2.72 2.72 0 0 0-.961-2.2 3.883 3.883 0 0 0-2.572-.8h-3.8v5.909h3.87a3.836 3.836 0 0 0 2.55-.771Z",
    transform: "translate(-119.891 -148.749)",
    fill: "url(#banner-title_svg__k)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19098",
    d: "M247.552 166.108h-21.224v-1.586h9.686v-2.164H228.3v-1.466h7.715v-1.972h-7.307v-8.22h16.369v8.221h-7.307v1.971h7.763v1.466h-7.763v2.164h9.782Zm-21.2 4.951a10.683 10.683 0 0 0 2.669-3.99l1.707.409a12.568 12.568 0 0 1-2.716 4.374Zm9.663-13.654v-5.191h-5.6v5.186Zm-3.077-4.591a12.562 12.562 0 0 1 1.562 3.509l-1.25.482a14.411 14.411 0 0 0-1.49-3.582Zm1.827 14.735a18.37 18.37 0 0 1 .529 3.823l-1.755.24a22.865 22.865 0 0 0-.433-3.943Zm8.534-15.335h-5.529v5.186h5.53Zm-3.605 15.166a22.323 22.323 0 0 1 1.37 3.8l-1.755.433a28.01 28.01 0 0 0-1.274-3.895Zm-.841-10.792a25.157 25.157 0 0 0 1.851-3.8l1.394.529c-.673 1.3-1.466 2.788-2.091 3.75Zm5.648 10.48a22.748 22.748 0 0 1 3.174 4.038l-1.732.673a24.265 24.265 0 0 0-3.052-4.159Z",
    transform: "translate(-119.833 -148.752)",
    fill: "url(#banner-title_svg__m)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19099",
    d: "M277.379 156.493a16.488 16.488 0 0 1-4.783 4.592 31.611 31.611 0 0 0 9.3 2.548 7.913 7.913 0 0 0-1.13 1.683 25.841 25.841 0 0 1-3.342-.674v7.066h-1.8v-.768h-9.494v.793h-1.73v-6.971c-1.274.386-2.548.673-3.8.937a6.65 6.65 0 0 0-.865-1.562 35.817 35.817 0 0 0 9.447-3 17.688 17.688 0 0 1-3.15-2.764 21.68 21.68 0 0 1-3.75 2.331 5.491 5.491 0 0 0-1.2-1.274 16.032 16.032 0 0 0 6.826-5.385l1.924.337c-.336.48-.721.936-1.106 1.418h7.138l.312-.072Zm-14.9-.023h-1.755v-4.52h9.567c-.338-.625-.721-1.346-1.082-1.923l1.731-.434a23.439 23.439 0 0 1 1.394 2.356h8.558v4.52h-1.8v-2.861h-16.61Zm14.038 7.933a29.2 29.2 0 0 1-5.672-2.284 31.341 31.341 0 0 1-5.361 2.284Zm-.889 5v-3.486h-9.498v3.483Zm-8.341-12.091a15.136 15.136 0 0 0 3.582 2.908 16.769 16.769 0 0 0 3.774-3h-7.263Z",
    transform: "translate(-119.784 -148.754)",
    fill: "url(#banner-title_svg__n)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19100",
    d: "M309.728 166.755h-15.576v-1.707h15.576Zm4.951-6.3s-.024.577-.072.841c-.553 6.249-1.082 8.726-2.019 9.639a2.511 2.511 0 0 1-1.923.768 34.218 34.218 0 0 1-3.775-.047 4.156 4.156 0 0 0-.552-1.731c1.538.144 3.077.168 3.677.168a1.506 1.506 0 0 0 1.058-.265c.7-.625 1.2-2.74 1.682-7.715h-15.334c.288-1.924.6-5.048.769-7.38l1.755.12a209.76 209.76 0 0 1-.553 5.6h9.327c.312-2.429.625-5.36.841-7.476h-13.581v-1.731h13.893l.288-.1 1.3.145c-.192 2.523-.577 6.177-.961 9.157Z",
    transform: "translate(-119.733 -148.751)",
    fill: "url(#banner-title_svg__o)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19101",
    d: "M335.444 162c-.937.288-1.852.577-2.765.841v6.851c0 .985-.216 1.418-.817 1.707a6.894 6.894 0 0 1-2.932.311 7.424 7.424 0 0 0-.529-1.609c.961.024 1.875.024 2.115 0 .312 0 .433-.1.433-.434v-6.321l-2.764.817-.5-1.731c.913-.216 2.043-.529 3.269-.865V156.3h-2.956v-1.659h2.956v-4.831h1.731v4.831h2.515v1.659h-2.524v4.807l2.548-.746Zm14.253 7.042v1.708h-14.614v-1.708h8.125a93.194 93.194 0 0 0 2.259-11.9l1.9.336c-.649 3.7-1.61 8.388-2.5 11.561Zm-.625-13.22h-12.858v-1.681h12.859Zm-9.59 12.116a91.481 91.481 0 0 0-1.635-10.241l1.562-.336a90.464 90.464 0 0 1 1.8 10.072Zm2.307-14.063a26.87 26.87 0 0 0-1.154-3.822l1.682-.433a31.358 31.358 0 0 1 1.2 3.726Z",
    transform: "translate(-119.684 -148.754)",
    fill: "url(#banner-title_svg__p)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19102",
    d: "M369.067 163.7c-.385-.889-1.25-2.476-2.019-3.8v11.827h-1.755v-11.25a26.989 26.989 0 0 1-3 6.85 10.287 10.287 0 0 0-.986-1.73 25.144 25.144 0 0 0 3.8-9.062h-3.438v-1.683h3.63v-5.071h1.755v5.071h2.98v1.683h-2.98v.961c.817 1.082 2.812 4.014 3.245 4.735Zm6.274-12.788a25.569 25.569 0 0 1-4.159 9.734 13.72 13.72 0 0 0-1.562-1.057 20.622 20.622 0 0 0 3.895-8.99Zm4.23 12.475a44.672 44.672 0 0 1 3.341 7.091l-1.634.768a16.918 16.918 0 0 0-.649-1.8c-8 1.057-9.062 1.226-9.735 1.562h-.024v-.1c-.144-.41-.433-1.226-.649-1.708.529-.143.985-.936 1.562-2.115a51.4 51.4 0 0 0 3.582-9.614l1.851.7a62.328 62.328 0 0 1-4.255 10.553l7.043-.842c-.6-1.321-1.25-2.691-1.9-3.87Zm-.264-13.052a23.518 23.518 0 0 0 4.062 8.8 5.874 5.874 0 0 0-1.418 1.466 27.656 27.656 0 0 1-4.326-9.88Z",
    transform: "translate(-119.634 -148.753)",
    fill: "url(#banner-title_svg__q)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19103",
    d: "M422.122 148.755v24.037h-1.009v-24.037Z",
    transform: "translate(-119.546 -148.755)",
    fill: "url(#banner-title_svg__r)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19104",
    d: "M464.774 164.122a19.371 19.371 0 0 0 2.921-3.292 5.931 5.931 0 0 0 1.19-3.377 3.712 3.712 0 0 0-.757-2.464 3.017 3.017 0 0 0-2.44-.9 3.207 3.207 0 0 0-2.537 1.02 4.264 4.264 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.207 6.207 0 0 1 7.9-.1 4.937 4.937 0 0 1 1.454 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.7 3.318q-1.513 1.43-3.869 3.329h8.268v1.826h-11.569v-1.561q3.051-2.446 4.782-4.024Z",
    transform: "translate(-119.489 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19105",
    d: "M485.29 154.58q1.346-2.319 4.711-2.32 3.339 0 4.686 2.32a12.919 12.919 0 0 1 1.347 6.452 13.169 13.169 0 0 1-1.347 6.539Q493.341 169.9 490 169.9q-3.366 0-4.711-2.331a13.159 13.159 0 0 1-1.347-6.539 12.908 12.908 0 0 1 1.348-6.45Zm8.3 2.907a4.528 4.528 0 0 0-1.13-2.343 3.9 3.9 0 0 0-4.952 0 4.513 4.513 0 0 0-1.13 2.343 19.361 19.361 0 0 0-.276 3.545 20.017 20.017 0 0 0 .276 3.629 4.518 4.518 0 0 0 1.13 2.356 3.892 3.892 0 0 0 4.952 0 4.533 4.533 0 0 0 1.13-2.356 20.116 20.116 0 0 0 .275-3.629 19.457 19.457 0 0 0-.271-3.544Z",
    transform: "translate(-119.454 -148.75)",
    fill: "url(#banner-title_svg__t)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19106",
    d: "M513.422 164.122a19.362 19.362 0 0 0 2.92-3.292 5.932 5.932 0 0 0 1.19-3.377 3.711 3.711 0 0 0-.757-2.464 3.016 3.016 0 0 0-2.439-.9 3.206 3.206 0 0 0-2.536 1.02 4.264 4.264 0 0 0-.973 2.729h-2.115a5.778 5.778 0 0 1 1.634-4.159 6.207 6.207 0 0 1 7.9-.1 4.933 4.933 0 0 1 1.454 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.7 3.318q-1.514 1.43-3.87 3.329h8.26v1.826h-11.561v-1.561q3.053-2.446 4.783-4.024Z",
    transform: "translate(-119.417 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19107",
    d: "M532.015 154.519v-1.994h4.519V169.9h-2.211v-15.381Z",
    transform: "translate(-119.383 -148.749)",
    fill: "url(#banner-title_svg__u)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19108",
    d: "M550.16 169.593a1.49 1.49 0 0 1 1.058-2.548 1.37 1.37 0 0 1 1.021.432 1.541 1.541 0 0 1 0 2.116 1.37 1.37 0 0 1-1.021.432 1.438 1.438 0 0 1-1.058-.432Z",
    transform: "translate(-119.357 -148.728)",
    fill: "url(#banner-title_svg__v)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19109",
    d: "M564.511 154.519v-1.994h4.518V169.9h-2.211v-15.381Z",
    transform: "translate(-119.335 -148.749)",
    fill: "url(#banner-title_svg__u)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19110",
    d: "M587.173 164.122a19.36 19.36 0 0 0 2.92-3.292 5.931 5.931 0 0 0 1.19-3.377 3.717 3.717 0 0 0-.756-2.464 3.017 3.017 0 0 0-2.44-.9 3.207 3.207 0 0 0-2.537 1.02 4.257 4.257 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.206 6.206 0 0 1 7.895-.1 4.934 4.934 0 0 1 1.455 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.705 3.318q-1.513 1.43-3.869 3.329h8.267v1.826h-11.56v-1.561q3.052-2.446 4.783-4.024Z",
    transform: "translate(-119.309 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19111",
    d: "M606.343 169.593a1.49 1.49 0 0 1 1.058-2.548 1.371 1.371 0 0 1 1.021.432 1.541 1.541 0 0 1 0 2.116 1.371 1.371 0 0 1-1.021.432 1.438 1.438 0 0 1-1.058-.432Z",
    transform: "translate(-119.274 -148.728)",
    fill: "url(#banner-title_svg__w)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19112",
    d: "M625.2 167.355a3.537 3.537 0 0 0 2.367.745 3.2 3.2 0 0 0 2.944-1.563q.949-1.561.9-5.264a3.629 3.629 0 0 1-1.682 1.7 5.588 5.588 0 0 1-2.62.613 6.109 6.109 0 0 1-2.872-.661 4.8 4.8 0 0 1-1.983-1.936 6.148 6.148 0 0 1-.721-3.076 5.786 5.786 0 0 1 1.49-4.147 5.549 5.549 0 0 1 4.23-1.574q3.365 0 4.723 2.188t1.358 6.514a19.311 19.311 0 0 1-.541 5 5.627 5.627 0 0 1-1.827 3 5.475 5.475 0 0 1-3.521 1.034 5.276 5.276 0 0 1-3.822-1.322 5.186 5.186 0 0 1-1.562-3.366h2.019a3.444 3.444 0 0 0 1.12 2.115Zm4.915-6.623a3.58 3.58 0 0 0 1.034-2.7 4.144 4.144 0 0 0-1.01-2.907 3.647 3.647 0 0 0-2.836-1.107 3.509 3.509 0 0 0-2.68 1.059 3.9 3.9 0 0 0-1 2.787 3.961 3.961 0 0 0 .985 2.813 3.719 3.719 0 0 0 2.86 1.058 3.647 3.647 0 0 0 2.647-1.002Z",
    transform: "translate(-119.251 -148.75)",
    fill: "url(#banner-title_svg__x)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19113",
    d: "M672.068 160.157v1.851h-9.59v-1.851Z",
    transform: "translate(-119.191 -148.738)",
    fill: "url(#banner-title_svg__y)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19114",
    d: "M706.5 164.122a19.406 19.406 0 0 0 2.92-3.292 5.931 5.931 0 0 0 1.19-3.377 3.712 3.712 0 0 0-.757-2.464 3.017 3.017 0 0 0-2.44-.9 3.209 3.209 0 0 0-2.537 1.02 4.264 4.264 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.207 6.207 0 0 1 7.9-.1 4.937 4.937 0 0 1 1.454 3.773 7.188 7.188 0 0 1-1.19 3.882 17.03 17.03 0 0 1-2.7 3.318q-1.514 1.43-3.87 3.329h8.268v1.826h-11.567v-1.561q3.051-2.446 4.782-4.024Z",
    transform: "translate(-119.133 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19115",
    d: "M727.016 154.58q1.346-2.319 4.711-2.32 3.339 0 4.686 2.32a12.919 12.919 0 0 1 1.347 6.452 13.169 13.169 0 0 1-1.347 6.539q-1.346 2.331-4.686 2.331-3.366 0-4.711-2.331a13.159 13.159 0 0 1-1.347-6.539 12.908 12.908 0 0 1 1.347-6.452Zm8.3 2.907a4.512 4.512 0 0 0-1.13-2.343 3.9 3.9 0 0 0-4.952 0 4.513 4.513 0 0 0-1.13 2.343 19.377 19.377 0 0 0-.275 3.545 20.033 20.033 0 0 0 .275 3.629 4.519 4.519 0 0 0 1.13 2.356 3.892 3.892 0 0 0 4.952 0 4.518 4.518 0 0 0 1.13-2.356 20.121 20.121 0 0 0 .275-3.629 19.463 19.463 0 0 0-.271-3.544Z",
    transform: "translate(-119.098 -148.75)",
    fill: "url(#banner-title_svg__t)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19116",
    d: "M755.149 164.122a19.409 19.409 0 0 0 2.92-3.292 5.932 5.932 0 0 0 1.19-3.377 3.712 3.712 0 0 0-.757-2.464 3.017 3.017 0 0 0-2.44-.9 3.209 3.209 0 0 0-2.537 1.02 4.264 4.264 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.207 6.207 0 0 1 7.9-.1 4.936 4.936 0 0 1 1.454 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.705 3.318q-1.513 1.43-3.869 3.329h8.268v1.826h-11.564v-1.561q3.051-2.446 4.783-4.024Z",
    transform: "translate(-119.061 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19117",
    d: "M778.837 164.122a19.406 19.406 0 0 0 2.92-3.292 5.93 5.93 0 0 0 1.19-3.377 3.712 3.712 0 0 0-.757-2.464 3.017 3.017 0 0 0-2.44-.9 3.207 3.207 0 0 0-2.537 1.02 4.264 4.264 0 0 0-.972 2.729h-2.116a5.774 5.774 0 0 1 1.635-4.159 6.207 6.207 0 0 1 7.9-.1 4.937 4.937 0 0 1 1.454 3.773 7.189 7.189 0 0 1-1.19 3.882 17 17 0 0 1-2.705 3.318q-1.513 1.43-3.869 3.329h8.268v1.826h-11.564v-1.561q3.051-2.446 4.783-4.024Z",
    transform: "translate(-119.026 -148.75)",
    fill: "url(#banner-title_svg__s)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19118",
    d: "M798.006 169.593a1.49 1.49 0 0 1 1.058-2.548 1.371 1.371 0 0 1 1.022.432 1.541 1.541 0 0 1 0 2.116 1.371 1.371 0 0 1-1.022.432 1.438 1.438 0 0 1-1.058-.432Z",
    transform: "translate(-118.992 -148.728)",
    fill: "url(#banner-title_svg__w)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19119",
    d: "M812.357 154.519v-1.994h4.519V169.9h-2.211v-15.381Z",
    transform: "translate(-118.97 -148.749)",
    fill: "url(#banner-title_svg__u)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19120",
    d: "M830.5 169.593a1.49 1.49 0 0 1 1.058-2.548 1.371 1.371 0 0 1 1.022.432 1.541 1.541 0 0 1 0 2.116 1.371 1.371 0 0 1-1.022.432 1.438 1.438 0 0 1-1.058-.432Z",
    transform: "translate(-118.944 -148.728)",
    fill: "url(#banner-title_svg__w)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 19121",
    d: "M849.358 167.355a3.537 3.537 0 0 0 2.367.745 3.2 3.2 0 0 0 2.944-1.563q.948-1.561.9-5.264a3.63 3.63 0 0 1-1.682 1.7 5.589 5.589 0 0 1-2.62.613 6.11 6.11 0 0 1-2.872-.661 4.8 4.8 0 0 1-1.983-1.936 6.149 6.149 0 0 1-.721-3.076 5.782 5.782 0 0 1 1.49-4.147 5.549 5.549 0 0 1 4.23-1.574q3.365 0 4.723 2.188t1.358 6.514a19.311 19.311 0 0 1-.541 5 5.628 5.628 0 0 1-1.827 3 5.475 5.475 0 0 1-3.521 1.034 5.276 5.276 0 0 1-3.822-1.322 5.186 5.186 0 0 1-1.562-3.366h2.019a3.434 3.434 0 0 0 1.12 2.115Zm4.915-6.623a3.58 3.58 0 0 0 1.034-2.7 4.144 4.144 0 0 0-1.01-2.907 3.648 3.648 0 0 0-2.836-1.107 3.508 3.508 0 0 0-2.68 1.059 3.9 3.9 0 0 0-1 2.787 3.961 3.961 0 0 0 .985 2.813 3.719 3.719 0 0 0 2.86 1.058 3.647 3.647 0 0 0 2.648-1.002Z",
    transform: "translate(-118.921 -148.75)",
    fill: "url(#banner-title_svg__x)"
  })))));
};
export default SvgBannerTitle;